import { DataStore } from 'aws-amplify';
import { QMReason } from '../models';
import { captureError } from '../common/sentry';

export interface QMReasonProps {
  id: string;
  reasonId: string;
  name: string;
}

export interface QMReasonDataProps {
  create: (data: QMReasonProps) => Promise<QMReasonProps | undefined>;
  getArray: () => Promise<QMReasonProps[] | undefined>;
}

export const qmReasonData = () => {
  async function create(data: QMReasonProps): Promise<QMReasonProps | undefined> {
    try {
      const created = await DataStore.save(
        new QMReason({
          id: data.id,
          reasonId: data.reasonId,
          name: data.name
        })
      );

      if (created) {
        return convertToProps(created);
      }

      return undefined;
    } catch (error) {
      console.error('Error creating QMReason:', error);
      captureError(error, `qmReason-create:${data.id}`);
      throw error;
    }
  }

  async function getArray(): Promise<QMReasonProps[] | undefined> {
    try {
      const results = await DataStore.query(QMReason);

      if (results) {
        return results.map((r) => convertToProps(r));
      }

      return undefined;
    } catch (error) {
      console.error('Error loading QMReason array:', error);
      captureError(error, 'qmReason-getArray');
      throw error;
    }
  }

  function convertToProps(data: QMReason) {
    const qmReasonProps: QMReasonProps = {
      id: data.id,
      reasonId: data.reasonId,
      name: data.name
    };
    return qmReasonProps;
  }

  const returned: QMReasonDataProps = {
    create,
    getArray
  };

  return returned;
};
